import React from 'react';
import { getCachedOrderSummary } from 'src/api/CachedApi';
import { OrderSummary } from 'src/types/orderSummary';

interface MarginDisplayProps {
  customerNumber: number;
  sfaOrderId: number;
  sfaOrderItemsLength: number;
  total: number;
}

const MarginDisplay: React.FC<MarginDisplayProps> = ({ customerNumber, sfaOrderId, sfaOrderItemsLength, total }) => {
  let summary: OrderSummary = null;

  if (customerNumber && sfaOrderId && (sfaOrderItemsLength ?? 0) > 0) {
    summary = React.use(getCachedOrderSummary(sfaOrderId, customerNumber, total, sfaOrderItemsLength));
  }

  const margin = summary?.marginPercent ?? 0;

  return (
    <span className="order-total pr-2">
      <span className="order-total-margin-label">Margin:</span> {margin > 0 ? margin.toFixed(4) : margin.toFixed(2)}%
    </span>
  );
};

export default MarginDisplay;
